












































































































































































































































import Vue from "vue";
import DashboardFilters from "./DashboardFilters.vue";
import Drilldown from "./Drilldown.vue";
import Widget from "../../components/Widget.vue";
import { FilterValues } from "./DashboardFilters.vue";
import {
  AutobedrijfViewModel,
  FixedPeriodType,
  DropdownItemModel,
} from "../../TypeScriptModels";
import { VestigingViewModel } from "./DashboardFilters.vue";
// werkt niet in IE: import TransitionExpand from "../../components/TransitionExpand.vue";
import debounce from "lodash-es/debounce";
import get from "lodash-es/get";
import map from "lodash-es/map";
import flatten from "lodash-es/flatten";
import sumBy from "lodash-es/sumBy";
import isEmpty from "lodash-es/isEmpty";
import groupBy from "lodash-es/groupBy";
import axios, { AxiosPromise } from "axios";
import { ApplicationActions } from "../../store";
import { Dispatcher, Committer } from "vuex-type-helper";
import moment from "moment";

export enum WidgetQueryType {
  WidgetSalesOpen = 1,
  WidgetSalesConversie = 2,
  WidgetAftersalesOpen = 3,
  WidgetAftersalesConversie = 4,
}

interface WidgetProperties {
  queryType: WidgetQueryType;
  widgetValue: number;
  name: string;
  widgetSubvalue: number;
  subPrefix: string;
}

export interface LeadConversieGroupedDataRowViewModel {
  AutobedrijfId: string; // group by AutobedrijfId
  VestigingId: string; // group by vestiging
  Leadbron: string; // group by lead bron
  Leadsoort: number; //group by lead soort

  Afgerond: number; // Sum(Afgerond)
  Succes: number; //Sum(Succes)
  Gemist: number; // Sum(Gemist)
  Verwijderd: number; // Sum(Verwijderd)
  Order: number; // Sum(Order)
  DLGehaald: number; // Sum(deadline gehaald)
  HeeftDLEnAfgerond: number; // Sum(heeft deadline)
}

export interface LeadOpenGroupedDataRowViewModel {
  AutobedrijfId: string; // group by AutobedrijfId
  VestigingId: string; // group by vestiging
  Leadbron: string; // group by lead bron
  Leadsoort: number; //group by lead soort

  Open: number; // Sum(open)
  Nieuw: number; //Sum(ongeopened)
  Lopend: number; // Sum(inbehandeling)
  DLVerstreken: number; // Sum(DeadlineVerstreken)
}

interface LeadsConversieGroupedDataViewModel {
  LandelijkConversie: number;
  QueryType: WidgetQueryType;
  Leads: LeadConversieGroupedDataRowViewModel[];
}

interface LeadsOpenGroupedDataViewModel {
  QueryType: WidgetQueryType;
  Leads: LeadOpenGroupedDataRowViewModel[];
}

export interface LeadsDrilldownDataViewModel {
  Key: string;
  Name: string;
  Leads:
    | LeadOpenGroupedDataRowViewModel[]
    | LeadConversieGroupedDataRowViewModel[];
}

interface DashboardQueryWidgetViewModel {
  FromDate: string;
  ToDate: string;
  QueryType: WidgetQueryType;
  Zones: number[];
  Autobedrijven: string[];
  Vestigingen: string[];
  Leadsoorten: number[];
  Merken: string[];
}

interface FilterDataOptions {
  Zones: DropdownItemModel[];
  Autobedrijven: AutobedrijfViewModel[];
  Vestigingen: VestigingViewModel[];
  SoortenLead: DropdownItemModel[];
}

export interface WidgetDataOpenViewModel {
  Id: string;
  Titel: string;

  Open: number; // Sum(open)
  Nieuw: number; //Sum(ongeopened)
  Lopend: number; // Sum(inbehandeling)
  DLVerstreken: number; // Sum(DeadlineVerstreken)
}

export interface WidgetDataConversieViewModel {
  Id: string;
  Titel: string;

  Afgerond: number; // Sum(Afgerond)
  Succes: number; //Sum(Succes)
  Gemist: number; // Sum(Gemist)
  Verwijderd: number; // Sum(Verwijderd)
  Conversie: number | string; //tot.succes / (tot.succes + tot.gemist)
  Order: number; // Sum(Order)
  DLGehaald: number; // Sum(deadline gehaald)
  HeeftDLEnAfgerond : number;  // Sum(heeft deadline en is afgerond)
  OrderRatio: number | string; //tot.orders / tot.afgerond
  DLRatio: number | string; //tot.dlgehaald / tot.heeftdeadlineenafgerond
}

export default Vue.extend({
  components: {
    DashboardFilters,
    Widget,
    Drilldown,
  },

  created() {
    this.selectedOptions.period = {
      Id: FixedPeriodType.ThisYear,
      Omschrijving: `${this.$i18n.t("timefilters.thisyear")}`,
    };
    this.getOpenSalesDataDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetSalesOpen);
    }, 5000);
    this.getConversieSalesDataDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetSalesConversie);
    }, 5000);
    this.getOpenAftersalesDataDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetAftersalesOpen);
    }, 5000);
    this.getConversieAftersalesDataDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetAftersalesConversie);
    }, 5000);
    
    this.getOpenSalesFilterDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetSalesOpen);
    }, 500);
    this.getConversieSalesFilterDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetSalesConversie);
    }, 500);
    this.getOpenAftersalesFilterDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetAftersalesOpen);
    }, 500);
    this.getConversieAftersalesFilterDebounced = debounce(() => {
      this.getLeadsData(WidgetQueryType.WidgetAftersalesConversie);
    }, 500);
  },

  mounted() {
    this.connect();
    this.destroyed = false;
  },

  data() {
    return {
      pageInitialised: false,
      waitConnect: 2500,
      timerRenewToken: 0,
      destroyed: false,
      websocket: null as null | WebSocket,
      selectedOptions: {
        period: null as null | any,
        zonesValue: [] as any[],
        autobedrijvenValue: [] as any[],
        vestigingenValue: [] as any[],
        soortenLeadValue: [] as any[],
        merkenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
      } as FilterValues,
      filteroptions: {} as null | FilterDataOptions,
      selectedWidget: null as WidgetQueryType | null,

      selectedRowIds: [] as any[],

      leadsOpenSales: null as LeadsOpenGroupedDataViewModel | null,
      leadsConversieSales: null as LeadsConversieGroupedDataViewModel | null,
      leadsOpenAftersales: null as LeadsOpenGroupedDataViewModel | null,
      leadsConversieAftersales: null as LeadsConversieGroupedDataViewModel | null,

      getOpenSalesDataDebounced: null as null | Function,
      getConversieSalesDataDebounced: null as null | Function,
      getOpenAftersalesDataDebounced: null as null | Function,
      getConversieAftersalesDataDebounced: null as null | Function,

      getOpenSalesFilterDebounced: null as null | Function,
      getConversieSalesFilterDebounced: null as null | Function,
      getOpenAftersalesFilterDebounced: null as null | Function,
      getConversieAftersalesFilterDebounced: null as null | Function,
    };
  },

  computed: {
    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },

    zoneGebruiker(): boolean {
      return this.$store.getters.zoneUser;
    },

    showOpenResults(): boolean {
      return (
        this.selectedWidget === WidgetQueryType.WidgetSalesOpen ||
        this.selectedWidget === WidgetQueryType.WidgetAftersalesOpen
      );
    },

    showConversieResults(): boolean {
      return (
        this.selectedWidget === WidgetQueryType.WidgetSalesConversie ||
        this.selectedWidget === WidgetQueryType.WidgetAftersalesConversie
      );
    },

    showSalesGrid(): boolean {
      return (
        this.selectedWidget === WidgetQueryType.WidgetSalesOpen ||
        this.selectedWidget === WidgetQueryType.WidgetSalesConversie
      );
    },

    showAftersalesGrid(): boolean {
      return (
        this.selectedWidget === WidgetQueryType.WidgetAftersalesOpen ||
        this.selectedWidget === WidgetQueryType.WidgetAftersalesConversie
      );
    },

    drilldownGroupBy(): string {
      if (!this.zoneGebruiker)
        return "VestigingId";
      const vestigingen = this.selectedOptions.vestigingenValue.map(
        (v) => v.Id
      );
      if (!isEmpty(vestigingen)) {
        return "VestigingId";
      }

      const autobedrijven = this.selectedOptions.autobedrijvenValue.map(
        (a) => a.Id
      );
      if (!isEmpty(autobedrijven)) {
        return autobedrijven.length === 1 ? "VestigingId" : "AutobedrijfId";
      }

      const zones = this.selectedOptions.zonesValue.map((g) => g.Id);
      return zones.length <= 1 ? "AutobedrijfId" : "ZoneId";
    },

    leadsGrouped(): any {
      let field = this.drilldownGroupBy;
      let widgetType = this.selectedWidget;
      if (!this.filteroptions || this.selectedWidget === null) return [];

      let leads = [] as any[];

      switch (widgetType) {
        case WidgetQueryType.WidgetSalesOpen:
          leads = get(
            this.leadsOpenSales,
            "Leads",
            []
          ) as LeadOpenGroupedDataRowViewModel[];
          break;
        case WidgetQueryType.WidgetSalesConversie:
          leads = get(
            this.leadsConversieSales,
            "Leads",
            []
          ) as LeadConversieGroupedDataRowViewModel[];
          break;
        case WidgetQueryType.WidgetAftersalesOpen:
          leads = get(
            this.leadsOpenAftersales,
            "Leads",
            []
          ) as LeadOpenGroupedDataRowViewModel[];
          break;
        case WidgetQueryType.WidgetAftersalesConversie:
          leads = get(
            this.leadsConversieAftersales,
            "Leads",
            []
          ) as LeadConversieGroupedDataRowViewModel[];
          break;
        default:
          break;
      }
      return leads;
    },

    drilldownData(): any {
      let field = this.drilldownGroupBy;
      let griddata = this.leadsGrouped;
      if (
        isEmpty(griddata) ||
        !this.filteroptions ||
        isEmpty(this.filteroptions.Vestigingen)
      )
        return null;

      let grouped = null;
      let groupbyFilter = null;

      if (field === "VestigingId") {
        groupbyFilter = (lead: any) => {
          return lead.VestigingId;
        };
      } else {
        let autobedrijven = get(
          this.filteroptions,
          "Autobedrijven",
          []
        ) as any[];

        if (field === "AutobedrijfId") {
          groupbyFilter = (lead: any) => {
            return autobedrijven.filter((v) => v.Id === lead.AutobedrijfId)[0]
              .Id;
          };
        } else if (field === "ZoneId") {
          groupbyFilter = (lead: any) => {
            return String(
              autobedrijven.filter((v) => v.Id === lead.AutobedrijfId)[0].ZoneId
            );
          };
        }
      }
      if (!groupbyFilter) return null;
      grouped = groupBy(griddata, groupbyFilter);
      if (isEmpty(grouped)) return null;

      return map(grouped, (leadsByKey, key) => {
        return {
          Key: key,
          Name: this.getOptionOmschrijving(field, key),
          Leads: leadsByKey,
        } as LeadsDrilldownDataViewModel;
      });
    },

    stackedDetailsLevelData(): any[] {
      let field = this.drilldownGroupBy;
      if (!this.selectedWidget) return [];
      if (!this.drilldownGroupBy || isEmpty(this.drilldownData)) return [];
      let stacks = [] as any[];
      let rowsStack0 = [] as
        | WidgetDataOpenViewModel[]
        | WidgetDataConversieViewModel[];
      let rowsStack1 = [] as
        | WidgetDataOpenViewModel[]
        | WidgetDataConversieViewModel[];
      let rowsStack2 = [] as
        | WidgetDataOpenViewModel[]
        | WidgetDataConversieViewModel[];

      let drillDownData = this.drilldownData as LeadsDrilldownDataViewModel[];
      let filteredLeads = [];
      let stackindex = 0;

      let leadsDrilldownDataByBron = null as null | any[];

      if (this.showOpenResults) {
        rowsStack0 = drillDownData.map((item) =>
          this.createWidgetDataOpenViewModel(item)
        );
      } else if (this.showConversieResults) {
        rowsStack0 = drillDownData.map((item) =>
          this.createWidgetDataConversieViewModel(item)
        );
      }

      if (!isEmpty(rowsStack0)) stacks.push(rowsStack0);

      if (stacks.length === 1 && !isEmpty(this.selectedRowIds)) {
        filteredLeads = [];
        stackindex = 0;
        if (this.selectedRowIds[stackindex].IsTotalRow) {
          filteredLeads = flatten(map(drillDownData, "Leads") as any[]);
        } else {
          let stackFilter = (row: LeadsDrilldownDataViewModel) => {
            return row.Key === String(this.selectedRowIds[stackindex].Id);
          };
          let filteredData = drillDownData.filter(stackFilter);
          if (filteredData.length > 0) filteredLeads = filteredData[0].Leads;
        }

        let groupedbyLeadbron = groupBy(
          filteredLeads,
          (lead: any) => lead.Leadbron
        );
        if (!isEmpty(groupedbyLeadbron)) {
          leadsDrilldownDataByBron = map(
            groupedbyLeadbron,
            (leadsByKey, key) => {
              return {
                Key: key,
                Name: key,
                Leads: leadsByKey as any[],
              } as LeadsDrilldownDataViewModel;
            }
          );

          if (this.showOpenResults) {
            rowsStack1 = leadsDrilldownDataByBron.map((item) =>
              this.createWidgetDataOpenViewModel(item)
            );
          } else if (this.showConversieResults) {
            rowsStack1 = leadsDrilldownDataByBron.map((item) =>
              this.createWidgetDataConversieViewModel(item)
            );
          }
        }
      }

      if (!isEmpty(rowsStack1)) stacks.push(rowsStack1);

      if (
        stacks.length === 2 &&
        !isEmpty(leadsDrilldownDataByBron) &&
        !isEmpty(this.selectedRowIds) &&
        this.selectedRowIds.length > 1
      ) {
        filteredLeads = [];
        stackindex = 1;

        if (this.selectedRowIds[stackindex].IsTotalRow) {
          filteredLeads = flatten(map(
            leadsDrilldownDataByBron,
            "Leads"
          ) as any[]);
        } else {
          let stackFilter = (row: LeadsDrilldownDataViewModel) => {
            return row.Key === String(this.selectedRowIds[stackindex].Id);
          };
          let filteredData = (leadsDrilldownDataByBron as any[]).filter(
            stackFilter
          );
          if (filteredData.length > 0) filteredLeads = filteredData[0].Leads;
        }
        let groupedbyLeadSoort = groupBy(
          filteredLeads,
          (lead: any) => lead.Leadsoort
        );

        if (!isEmpty(groupedbyLeadSoort)) {
          let leadsDrilldownDataBySoort = map(
            groupedbyLeadSoort,
            (leadsByKey, key) => {
              return {
                Key: key,
                Name: this.getOptionOmschrijving("Leadsoort", key),
                Leads: leadsByKey as any[],
              } as LeadsDrilldownDataViewModel;
            }
          );

          if (this.showOpenResults) {
            rowsStack2 = leadsDrilldownDataBySoort.map((item) =>
              this.createWidgetDataOpenViewModel(item)
            );
          } else if (this.showConversieResults) {
            rowsStack2 = leadsDrilldownDataBySoort.map((item) =>
              this.createWidgetDataConversieViewModel(item)
            );
          }
        }
      }

      if (!isEmpty(rowsStack2)) stacks.push(rowsStack2);

      return stacks;
    },

    //widget 1
    leadsSalesOpened(): boolean {
      return this.selectedWidget === WidgetQueryType.WidgetSalesOpen;
    },

    leadsSalesDimmed(): boolean {
      return (
        this.selectedWidget !== null &&
        this.selectedWidget !== WidgetQueryType.WidgetSalesOpen
      );
    },

    leadsSalesWidget(): WidgetProperties {
      const widgetText = `${this.$i18n.t("widget1")}`;
      const type = WidgetQueryType.WidgetSalesOpen;
      const value = !!this.leadsOpenSales
        ? sumBy(this.leadsOpenSales.Leads, "Open")
        : -1;

      return this.createWidgetProperties(widgetText, type, value, 0, "");
    },

    //widget 2
    leadsSalesConversieOpened(): boolean {
      return this.selectedWidget === WidgetQueryType.WidgetSalesConversie;
    },

    leadsSalesConversieDimmed(): boolean {
      return (
        this.selectedWidget !== null &&
        this.selectedWidget !== WidgetQueryType.WidgetSalesConversie
      );
    },

    leadsSalesConversieWidget(): WidgetProperties {
      const widgetText = `${this.$i18n.t("widget2")}`;
      const prefix = `${this.$i18n.t("prefixConversion")}`;

      const type = WidgetQueryType.WidgetSalesConversie;
      const afgerond =
        !!this.leadsConversieSales && !isEmpty(this.leadsConversieSales.Leads)
          ? sumBy(this.leadsConversieSales.Leads, "Afgerond")
          : 0;
      const succes =
        !!this.leadsConversieSales && !isEmpty(this.leadsConversieSales.Leads)
          ? sumBy(this.leadsConversieSales.Leads, "Succes")
          : 0;
      const gemist =
        !!this.leadsConversieSales && !isEmpty(this.leadsConversieSales.Leads)
          ? sumBy(this.leadsConversieSales.Leads, "Gemist")
          : 0;

      let selectedratio =
        succes + gemist == 0 ? 0 : (100.0 * succes) / (succes + gemist);

      const landelijk = get(this.leadsConversieSales, "LandelijkConversie", 0);

      if (selectedratio === 0 && this.leadsConversieSales === null) {
        selectedratio = -1;
      }

      return this.createWidgetProperties(
        widgetText,
        type,
        selectedratio,
        landelijk,
        prefix
      );
    },

    //widget 3
    leadsAftersalesOpened(): boolean {
      return this.selectedWidget === WidgetQueryType.WidgetAftersalesOpen;
    },

    leadsAftersalesDimmed(): boolean {
      return (
        this.selectedWidget !== null &&
        this.selectedWidget !== WidgetQueryType.WidgetAftersalesOpen
      );
    },

    leadsAftersalesWidget(): WidgetProperties {
      const widgetText = `${this.$i18n.t("widget3")}`;
      const type = WidgetQueryType.WidgetAftersalesOpen;
      const value = !!this.leadsOpenAftersales
        ? sumBy(this.leadsOpenAftersales.Leads, "Open")
        : -1;

      return this.createWidgetProperties(widgetText, type, value, 0, "");
    },

    //widget 4
    leadsAftersalesConversieOpened(): boolean {
      return this.selectedWidget === WidgetQueryType.WidgetAftersalesConversie;
    },

    leadsAftersalesConversieDimmed(): boolean {
      return (
        this.selectedWidget !== null &&
        this.selectedWidget !== WidgetQueryType.WidgetAftersalesConversie
      );
    },

    leadsAftersalesConversieWidget(): WidgetProperties {
      const widgetText = `${this.$i18n.t("widget4")}`;
      const prefix = `${this.$i18n.t("prefixConversion")}`;

      const type = WidgetQueryType.WidgetAftersalesConversie;
      const afgerond =
        !!this.leadsConversieAftersales &&
        !isEmpty(this.leadsConversieAftersales.Leads)
          ? sumBy(this.leadsConversieAftersales.Leads, "Afgerond")
          : 0;
      const succes =
        !!this.leadsConversieAftersales &&
        !isEmpty(this.leadsConversieAftersales.Leads)
          ? sumBy(this.leadsConversieAftersales.Leads, "Succes")
          : 0;
      const gemist =
        !!this.leadsConversieAftersales &&
        !isEmpty(this.leadsConversieAftersales.Leads)
          ? sumBy(this.leadsConversieAftersales.Leads, "Gemist")
          : 0;

      let selectedratio =
        succes + gemist == 0 ? 0 : (100.0 * succes) / (succes + gemist);

      const landelijk = get(
        this.leadsConversieAftersales,
        "LandelijkConversie",
        0
      );
      if (selectedratio === 0 && this.leadsConversieAftersales === null) {
        selectedratio = -1;
      }
      return this.createWidgetProperties(
        widgetText,
        type,
        selectedratio,
        landelijk,
        prefix
      );
    },
  },

  methods: {
    connect() {
      if (!this.destroyed && "WebSocket" in window) {
        let that = this;
        let protocol = location.protocol === "https:" ? "wss://" : "ws://";

        this.websocket = new WebSocket(
          protocol + location.host + "/api/backend/v1/dashboard/leads/live"
        );

        this.websocket.onopen = () => {
          this.waitConnect = 2500;
          //console.log("websocked opened!");
          if (!this.timerRenewToken) {
            this.timerRenewToken = setInterval(this.renewToken, 30 * 60 * 1000);
          }
        };

        this.websocket.onmessage = (evt) => {
          const received_msg = evt.data;
          //console.log(Math.floor(Date.now()) + "  " + received_msg);

          try {
            let obj = JSON.parse(evt.data);
            let querytypes = get(obj, "WidgetType", []) as WidgetQueryType[];
            if (!isEmpty(querytypes)) this.onUpdate(querytypes);
          } catch (err) {}
        };

        this.websocket.onclose = () => {
          // console.log("websocked closed");
          if (!this.destroyed) {
            // Reconnect will be attempted after a while
            setTimeout(() => {
              if (this.waitConnect > 1000 * 6) {
                this.$router.push({ name: "logout" });
              } else {
                that.connect();
                this.waitConnect += 500;
              }
            }, this.waitConnect);
          }
        };
      }
    },

    onWidgetClicked(id: WidgetQueryType) {
      if (!this.pageInitialised) return;
      this.selectedWidget = this.selectedWidget === id ? null : id;
      if (this.selectedWidget === null) {
        this.selectedRowIds = [];
      }
    },

    createWidgetProperties(
      name: string,
      type: WidgetQueryType,
      widgetValue: number,
      widgetSubvalue: number,
      widgetSubPrefix: string
    ): WidgetProperties {
      return {
        queryType: type,
        widgetValue: widgetValue,
        name: name,
        widgetSubvalue: widgetSubvalue,
        subPrefix: widgetSubPrefix,
      };
    },

    createWidgetDataOpenViewModel(
      model: LeadsDrilldownDataViewModel
    ): WidgetDataOpenViewModel {
      const leads = get(
        model,
        "Leads",
        []
      ) as LeadOpenGroupedDataRowViewModel[];
      return {
        Id: model.Key,
        Titel: model.Name,

        Open: sumBy(leads, "Open"),
        Nieuw: sumBy(leads, "Nieuw"),
        Lopend: sumBy(leads, "Lopend"),
        DLVerstreken: sumBy(leads, "DLVerstreken"),
      } as WidgetDataOpenViewModel;
    },

    createWidgetDataConversieViewModel(
      model: LeadsDrilldownDataViewModel
    ): WidgetDataConversieViewModel {
      const leads = get(
        model,
        "Leads",
        []
      ) as LeadConversieGroupedDataRowViewModel[];
      const afgerond = sumBy(leads, "Afgerond");
      const succes = sumBy(leads, "Succes");
      const gemist = sumBy(leads, "Gemist");
      const order = sumBy(leads, "Order");
      const gehaald = sumBy(leads, "DLGehaald");
      const heeftDLEnAfgerond = sumBy(leads, "HeeftDLEnAfgerond");

      return {
        Id: model.Key,
        Titel: model.Name,

        Afgerond: afgerond,
        Succes: succes,
        Gemist: gemist,
        Verwijderd: sumBy(leads, "Verwijderd"),
        Order: order,
        DLGehaald: gehaald,
        HeeftDLEnAfgerond: heeftDLEnAfgerond,
        Conversie:
          Math.round(
            succes + gemist === 0 ? 0.0 : (100.0 * succes) / (succes + gemist)
          ) + "%",
        OrderRatio:
          Math.round(
            succes + gemist === 0 ? 0.0 : (100.0 * order) / (succes + gemist)
          ) + "%",
        DLRatio:
          (Math.round(
            heeftDLEnAfgerond === 0 ? 100.0 : (100.0 * gehaald) / (heeftDLEnAfgerond * 1.0)
          ) + "%")
      } as WidgetDataConversieViewModel;
    },

    onOptionsInitialised(options: FilterDataOptions) {
      this.filteroptions = options;
    },

    onFiltersInitialised() {
      this.pageInitialised = true;
      this.onFilterPreferencesChanged();
    },

    onFilterPreferencesChanged() {
      this.handleOpenSalesFilterChanged();
      this.handleConversieSalesFilterChanged();
      this.handleOpenAftersalesFilterChanged();
      this.handleConversieAfteralesFilterChanged();
    },

    handleOpenSalesFilterChanged() {
      if (!!this.getOpenSalesFilterDebounced) 
        this.getOpenSalesFilterDebounced();
    },

    handleConversieSalesFilterChanged() {
      if (!!this.getConversieSalesFilterDebounced)
        this.getConversieSalesFilterDebounced();
    },

    handleOpenAftersalesFilterChanged() {
      if (!!this.getOpenAftersalesFilterDebounced)
        this.getOpenAftersalesFilterDebounced();
    },

    handleConversieAfteralesFilterChanged() {
      if (!!this.getConversieAftersalesFilterDebounced)
        this.getConversieAftersalesFilterDebounced();
    },

    onUpdate(types: WidgetQueryType[]) {
      if (isEmpty(types)) return;
      types.forEach((type) => {
        if (type === WidgetQueryType.WidgetSalesOpen)
          this.handleOpenSalesDataChanged();
        if (type === WidgetQueryType.WidgetSalesConversie)
          this.handleConversieSalesDataChanged();
        if (type === WidgetQueryType.WidgetAftersalesOpen)
          this.handleOpenAftersalesDataChanged();
        if (type === WidgetQueryType.WidgetAftersalesConversie)
          this.handleConversieAfteralesDataChanged();
      });
    },

    handleOpenSalesDataChanged() {
      if (!!this.getOpenSalesDataDebounced) this.getOpenSalesDataDebounced();
    },

    handleConversieSalesDataChanged() {
      if (!!this.getConversieSalesDataDebounced)
        this.getConversieSalesDataDebounced();
    },

    handleOpenAftersalesDataChanged() {
      if (!!this.getOpenAftersalesDataDebounced)
        this.getOpenAftersalesDataDebounced();
    },

    handleConversieAfteralesDataChanged() {
      if (!!this.getConversieAftersalesDataDebounced)
        this.getConversieAftersalesDataDebounced();
    },

    onRowSelected(data: any) {
      if (!!data) {
        if (data.StackId === 0 || data.StackId === 1) {
          //mutates the array:
          this.selectedRowIds.splice(data.StackId, 1, {
            IsTotalRow: data.IsTotalRow,
            Id: data.Id,
          });
        }
      }
    },

    onRowDeselected(data: any) {
      if (!!data) {
        if (data.StackId === 0) {
          this.selectedRowIds = [];
        } else if (data.StackId === 1) {
          this.selectedRowIds = [this.selectedRowIds[0]];
        }
      }
    },

    getLeadsData(queryType: WidgetQueryType) {
      this.queryData(queryType)
        .then((response) => {
          if (!!response && !!response.data) {
            const type = response.data.QueryType;

            if (type === WidgetQueryType.WidgetSalesOpen)
              this.leadsOpenSales = response.data;
            if (type === WidgetQueryType.WidgetSalesConversie)
              this.leadsConversieSales = response.data;
            if (type === WidgetQueryType.WidgetAftersalesOpen)
              this.leadsOpenAftersales = response.data;
            if (type === WidgetQueryType.WidgetAftersalesConversie)
              this.leadsConversieAftersales = response.data;
          }
        })
        .catch((error) => {});
    },

    getOptionOmschrijving(groupByField: string, Id: string) {
      if (!this.filteroptions) return "";
      let unknownText = `${this.$i18n.t("unknown")}`;
      let options = [] as any[];
      switch (groupByField) {
        case "VestigingId":
          options = this.filteroptions.Vestigingen;
          unknownText = `${this.$i18n.t("nobranch")}`
          break;
        case "AutobedrijfId":
          options = this.filteroptions.Autobedrijven;
          break;
        case "ZoneId":
          options = this.filteroptions.Zones;
          break;
        case "Leadsoort":
          options = this.filteroptions.SoortenLead;
          break;
        default:
          return "";
      }
      let option = options.filter((o) => String(o.Id) === String(Id));
      
      return isEmpty(option) ? unknownText : option[0].Omschrijving;
    },

    queryData(queryType: WidgetQueryType): AxiosPromise {
      const isCustomInput =
        get(this.selectedOptions, "period.Id", FixedPeriodType.ThisYear) ===
        FixedPeriodType.FreePeriod;

      let model = {
        FromDate: isCustomInput
          ? (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString()
          : this.selectedOptions.periodFromDate.toISOString(),
        ToDate: isCustomInput
          ? (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString()
          : this.selectedOptions.periodToDate.toISOString(),	        
        QueryType: queryType,

        Zones: get(this.selectedOptions as Object, "zonesValue", []).map(
          (elem: any) => Number(elem["Id"])
        ),
        Autobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        Vestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        Leadsoorten: get(
          this.selectedOptions as Object,
          "soortenLeadValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        Merken: [],
      } as DashboardQueryWidgetViewModel;

      if (this.multipleMakes) {
        model.Merken = get(
          this.selectedOptions as Object,
          "merkenValue",
          []
        ).map((elem: any) => String(elem["Id"]));
      }

      return axios.post("/api/backend/v1/dashboard/leads/query", model, {
        headers: { "Content-Type": "application/json" },
      });
    },

    renewToken() {
      this.$store.dispatch<Dispatcher<ApplicationActions>>({
        type: "renewTokenIfOutdated",
      });
    },
  },

  beforeDestroy() {
    this.destroyed = true;
    if (!!this.websocket) {
      this.websocket.onopen = null;
      this.websocket.onmessage = null;
      this.websocket.onclose = null;
      this.websocket.onerror = null;

      this.websocket.close();
      this.websocket = null;
    }
    if (!!this.timerRenewToken) {
      clearInterval(this.timerRenewToken);
    }
  },
});
